<template>
    <div class="breedingPig">
        <h3>整个周期报告</h3>
    <!-- 关键生产指标分析 -->
        <div class="part">
            <h4>关键生产指标分析</h4>
            <van-row class="production">
                <van-col span="8">
                    <div> {{detail.feedDays}}<span>天</span> </div>
                    <span>饲养天数</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.weightOfDay}}<span>g/天</span> </div>
                    <span>日增重</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.meatFeedProportion}}</div>
                    <span>料肉比</span>
                </van-col>
            </van-row>
            <van-row class="production">
                <van-col span="8">
                    <div> {{detail.positiveRate}}<span>%</span> </div>
                    <span>正品率</span>
                </van-col>
                <van-col span="8">
                    <div> {{detail.deadRate}}<span>%</span> </div>
                    <span>死淘率</span>
                </van-col>
            </van-row>
            <div class="line"></div>
            <div class="chart" id="barChart" style="width: 100%; height: 200px;"></div>
            <van-row class="chart-btn">
                <van-col span="8" :class="{'bar-active':checkedBar == bar.type}" @click="checkBar(bar.type)" v-for="bar in batBtn" :key="bar.type">{{bar.text}}</van-col>
            </van-row>
        </div>
    <!-- 生产成本分析 -->

    <!-- 预防分析 -->
        <div class="part preven">
            <h4>预防分析</h4>
            <p v-for="vacc in detail.vaccineList" :key="vacc">{{vacc}}</p>
            <p v-if="detail.vaccineList.length == 0" class="no-info">暂无数据</p>
            <p class="succ" v-else>以上疫病免疫更好，建议进行疫苗免疫效果评估，了解猪群更健康</p>
        </div>
        
        <div class="part health" v-if="detail.healthCareDesc != null">
            <h4>保健分析</h4>
            <p>{{detail.healthCareDesc}}</p>
        </div>

        <div class="part disinfect">
            <h4>消毒分析</h4>
            <p class="dis-all">{{detail.disinfectionNum}}</p>
            <p v-if="detail.disinfectionNum == null" class="no-info">本阶段没有做任何消毒！</p>
            <p v-else v-for="disin in detail.disinfectionDesc" :key="disin">{{disin}}</p>
        </div>

        <div class="part test">
            <h4>检测分析</h4>
            <p v-if="detail.checkList.length == 0" class="no-info">本阶段没有做任何检测！</p>
            <p v-else v-for="check in detail.checkList" :key="check">{{check}}</p>
        </div>

        <div class="part synthesize">
            <h4>综合分析</h4>
            <div class="status">
                <p>{{detail.complexBTNRate}}</p>
                <p>整体健康状况：<span>{{detail.complexRating}}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'
import { GetWholeReport } from '@/api/resetApi.js'
import { Toast } from 'vant';
export default {
    name:'breedingPig',
    data(){
        return{
            dossierId:null,
            detail:{
                vaccineList:[],
                checkList:[]
            },
            batBtn:[
                { text:'饲养天数', type:'1' },
                { text:'日增重', type:'2' },
                { text:'料肉比', type:'3' },
                { text:'正品率', type:'4' },
                { text:'死淘率', type:'5' }
            ],
            checkedBar:'1'
        }
    },
    created(){
        this.dossierId = this.$route.query.dossierId
        localStorage.setItem('utoken',this.$route.query.uToken)
        localStorage.setItem('sysCode',this.$route.query.sysCode)

        this.getWholeReport()
    },
    methods:{
        checkBar(type){
            this.checkedBar = type
            var data = null;
            if(type == 1){
                data = this.detail.feedDaysCompared
            }else if(type == 2){
                data = this.detail.weightOfDayCompared
            }else if(type == 3){
                data = this.detail.meatFeedProportionCompared
            }else if(type == 4){
                data = this.detail.positiveRateCompared
            }else{
                data = this.detail.deadRateCompared
            }
            this.setBarOption(data)
        },
        async getWholeReport(){
            let data = {
                dossierId:this.dossierId
            }
            let res = await GetWholeReport(data)
            try {
                if (res.data.code === 200) {
                    this.detail = res.data.data
                    this.setBarOption(this.detail.feedDaysCompared)
                }else{
                    Toast(res.data.msg)
                }
            } catch (error) {
                
            }
        },
        // 柱状图配置
        setBarOption(data){
            // 柱状图
            var barOptions ={
                legend: {
                    data: []
                },
                tooltip:{
                    showDelay : 0,
                },
                grid: {
                    x:40,
                    x2: 5,
                    y: 20,
                    y2: 28
                },
                xAxis: [{
                    type: 'category',
                    data: ['哺乳阶段', '保育阶段', '育肥阶段'],
                    axisTick: {
                        show: false
                    }
                }],
                yAxis: [{
                    type: 'value',
                    splitLine:{
                　　　　show:false
                　　 },
                    axisTick: {
                        show: false
                    }
                }],
                series: [{
                    color:['#C33531','#EFE42A','#64BD3D'],
                    name: '',
                    type: 'bar',
                    data: [data[0].val, data[1].val, data[2].val],
                    barWidth:30,
                    itemStyle: {
                        color: function(params) { 
                            var colorList = ['#2574F6','#F5A623','#26B798']; 
                            return colorList[params.dataIndex] 
                        }
                    },
                }]
            }
            var pieChart = echarts.init(document.getElementById('barChart'));
            pieChart.setOption(barOptions);
            // if(data[0].val == 0 && data[1].val == 0 && data[2].val == 0 ){
            //     vm.$data.barShow = false
            // }else{
            //     vm.$data.barShow = true;
            //     setTimeout(function(){
                    
            //     },300)
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
    .breedingPig{
        font-size: 14px;
        padding: 30px 15px;
        background: #26B798;
        color: #4A4A4A;
        text-align: left;
        p{
            line-height: 25px;
        }
        .no-info{
            text-align: center;
            color:#EA4747;
            line-height: 24px;
            margin: 8px 0;
        }
        h3{
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 44px;
        }
        .part{
            padding: 16px 10px 16px 14px;
            background: #fff;
            border-radius: 16px;
            margin-bottom: 12px;
            h4{
                text-align: center;
                font-size: 16px;
                color: #181818;
                margin-bottom: 18px;
                font-weight: bold;
            }
            .pro-list{
                text-align: left;
                line-height: 30px;
            }
            .line{
                width: 100%;
                border-bottom: 1px solid #26B798;
                position: relative;
                margin-bottom: 12px;
                &:after,&:before{
                    display: inline-block;
                    content: "";
                    width:9px;
                    height:9px;
                    background:rgba(38,183,152,1);
                    position: absolute;
                    transform: rotate(45deg);
                    top: -4px;
                }
                &:before{
                    right: 0;
                }
            }
            .chart-btn{
                margin-top: 10px;
                .van-col{
                    width:58px;
                    height:24px;
                    background:#fff;
                    border: 1px solid #CCCCCC;
                    border-radius:20px;
                    text-align: center;
                    line-height: 26px;
                    font-size: 10px;
                    margin-right: 7px;
                    &:last-child{
                        margin-right: 0;
                    }
                    &.bar-active{
                        background: #26B798;
                        border: 1px solid #26B798;
                        color: #fff;
                    }
                }
            }
        }
        .production{
            margin-bottom: 20px;
            .van-col{
                text-align: center;
                &>div{
                    color: #26B798;
                    font-size: 18px;
                    margin-bottom: 12px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        .preven{
            p{
                line-height: 30px; 
            }
            .succ{
                color: #26B798;
                line-height: 26px;
                margin: 14px 0;
            }
            .err{
                color: #EA4747;
                line-height: 26px;
                margin-top: 20px
            }
        }
        .disinfect{
            .dis-all{
                margin-bottom: 10px;
            }
        }
        .synthesize{
            .status{
                p{
                    line-height: 24px;
                    span{
                        color: #26B798
                    }
                }
            }
        }
    }
</style>